import { Screens } from '@shared/constants/screens';
import { screenGroupMap, GroupName } from '@config/default.config';
import { IScreenOrderItem } from './buildFlowTransitions';

// Get the first screen/entry point of each active group
export const buildActiveJourney = (screenOrder: IScreenOrderItem[]): Screens[] => {
  return [...screenOrder]
    .sort((a, b) => a.orderNumber - b.orderNumber)
    .map((item) => {
      const group = screenGroupMap[item.pageName as GroupName];
      // First key of the group object is the entry screen
      return group ? (Object.keys(group)[0] as Screens) : null;
    })
    .filter((screen): screen is Screens => screen !== null);
};

export const resolveJourneyScreen = (
  resolvedScreen: Screens,
  currentScreen: Screens,
  activeJourney: Screens[]
): Screens => {
  const activeSet = new Set(activeJourney);

  // Resolved screen is an active entry point — go directly
  if (activeSet.has(resolvedScreen)) {
    return resolvedScreen;
  }

  // Resolved screen is internal to a group — always navigate directly, no skipping needed
  const isInternalScreen = !Object.values(screenGroupMap).some(
    (group) => Object.keys(group)[0] === resolvedScreen
  );

  if (isInternalScreen) {
    return resolvedScreen;
  }

  // Resolved screen is a skipped group entry — find next active entry point
  const currentIndex = activeJourney.indexOf(currentScreen);
  const searchFrom = currentIndex === -1 ? 0 : currentIndex + 1;

  const nextActiveScreen = activeJourney
    .slice(searchFrom)
    .find((screen) => activeSet.has(screen));

  if (nextActiveScreen) {
    console.info(
      `"${resolvedScreen}" is a skipped group entry. ` +
      `Jumping to next active entry: "${nextActiveScreen}"`
    );
    return nextActiveScreen;
  }

  console.warn(`No next active screen found after "${currentScreen}". Falling back to "${resolvedScreen}"`);
  return resolvedScreen;
};